// Hugo Boss Style: Horizontal Image Gallery with Pagination Dots
// Creates dynamic pagination dots for product image gallery on mobile

document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth > 749) return; // Only on mobile

  const mediaGalleries = document.querySelectorAll('media-gallery');
  
  mediaGalleries.forEach(gallery => {
    const mediaList = gallery.querySelector('.product__media-list');
    const mediaItems = gallery.querySelectorAll('.product__media-item');
    const mediaWrapper = gallery.closest('.product__media-wrapper');
    
    if (!mediaList || !mediaWrapper || mediaItems.length <= 1) return;

    // Dots functionality removed - no pagination dots will be created
  });
});
